import {
  useRef,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { isHasSubNavigation, isHasSubSmallNavigation } from 'helpers/navigation';

export const useNav = ({
  theme,
  isPageScrolling,
  navLinks: links,
  isHeader,
  setDesktopMenu,
  isDropMenuOpened,
}) => {
  const navRef = useRef(null);
  const [isSmallDropMenuOpened, setIsSmallDropMenuOpened] = useState(false);
  const [selectedSlug, setSlug] = useState(null);
  const [hasOpenedSmallMenuInSession, setHasOpenedSmallMenuInSession] = useState(false);
  const [disableSmallDropMenuAnimation, setDisableSmallDropMenuAnimation] = useState(false);

  const openDropDownMenu = (slug) => {
    if (isHeader && isHasSubNavigation(slug)) {
      setDesktopMenu(true);
      setIsSmallDropMenuOpened(false);
    } else if (isHeader && isHasSubSmallNavigation(slug)) {
      setDesktopMenu(false);
      setIsSmallDropMenuOpened(true);
    }
  };

  const closeDropDownMenu = useCallback(() => {
    setDesktopMenu(false);
  }, [setDesktopMenu]);

  const closeSmallDropDownMenu = useCallback(() => setIsSmallDropMenuOpened(false), []);

  const handleOnClick = (slug) => () => {
    if (isDropMenuOpened && (slug === selectedSlug)) {
      setSlug(null);
      closeDropDownMenu();
    } else if (isSmallDropMenuOpened) {
      setSlug(null);
      closeSmallDropDownMenu();
    } else {
      openDropDownMenu(slug);
      setSlug(slug);
    }
  };

  const toggleMenu = ({ slug, isOpen }) => {
    if (isOpen) {
      if (hasOpenedSmallMenuInSession) {
        setDisableSmallDropMenuAnimation(true);
      } else {
        setHasOpenedSmallMenuInSession(true);
        setDisableSmallDropMenuAnimation(false);
      }
    }

    setIsSmallDropMenuOpened(isOpen);
    setSlug(isOpen ? slug : null);
  };

  const handleNavMouseEnter = () => {
    setHasOpenedSmallMenuInSession(false);
    setDisableSmallDropMenuAnimation(false);
  };

  const handleNavMouseLeave = () => {
    setHasOpenedSmallMenuInSession(false);
    setDisableSmallDropMenuAnimation(false);
  };

  useEffect(() => {
    const handleClickOutside = ({ target }) => {
      const { current } = navRef || {};

      if ((isDropMenuOpened || isSmallDropMenuOpened) && current && !current.contains(target)) {
        closeDropDownMenu();
        closeSmallDropDownMenu();
        setSlug(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [closeDropDownMenu, isDropMenuOpened, isSmallDropMenuOpened, setSlug, closeSmallDropDownMenu]);

  return {
    navRef,
    theme,
    isPageScrolling,
    links,
    isHeader,
    handleOnClick,
    isSmallDropMenuOpened,
    isDropMenuOpened,
    closeDropDownMenu,
    closeSmallDropDownMenu,
    selectedSlug,
    toggleMenu,
    disableSmallDropMenuAnimation,
    handleNavMouseEnter,
    handleNavMouseLeave,
  };
};
